import { PleriPageLoader } from '@plerionhq/design-system/experimental';
import { useLocation } from 'react-router-dom';

export const PleriLoaderPreview = () => {
  const { search } = useLocation();
  const face = new URLSearchParams(search).get('face');

  return (
    <PleriPageLoader
      face={face === 'smile' || face === 'uwu' ? face : 'random'}
    />
  );
};
